// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function AdditionalStorageRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['AdditionalStorage']

   if (state.product_list['addStorage']?.NotInPricebook) {
      return <> </>
   }

   if (
      permissions.includes(state.user_role) ||
      state.productAdditionalStorageCount > 0
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['addStorage']['ProductName']} (
               {formatFloatAsCurrencySymbol(
                  state.product_list['addStorage']['EmpListPrice'],
                  state.currencyObject,
               )}
               )
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  value={
                     state.productAdditionalStorageCount <= 0
                        ? ''
                        : state.productAdditionalStorageCount.toString()
                  }
                  onChange={(e) =>
                     state.onProductAdditionalStorageCountChange(
                        Number(e.target.value),
                     )
                  }
                  onBlur={() =>
                     state.onProductAdditionalStorageCountChange(
                        state.productAdditionalStorageCount < 1
                           ? 0
                           : Math.floor(state.productAdditionalStorageCount),
                     )
                  }
                  min={0}
                  placeholder={'0'}
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.AdditionalStorageCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
